import axios from 'axios';
import _ from "lodash";

const state = {
    brands: [],
    brandLoaded: false,
    shippers: [],
    shippingLoaded: false,
    bagTypes: [],
    bagTypesLoaded: false,
    market: [],
    market_timeout: null,
    marketLoaded: false,
    get_request: {'list': {}},
    update_var: false,
};

const getters = {
};

const actions = {
    LOAD_BRAND: ({commit, dispatch, state}, callback) => {
        if (state.brandLoaded) {
            callback(_.cloneDeep(state.brands));
        } else {
            axios.get('/brands')
                .then(response => {
                    commit('FINISH_BRAND', {callback: callback, brands: response.data.data});
                });
        }
    },
    LOAD_SHIPPERS: ({commit, dispatch, state}, callback) => {
        if (state.shippingLoaded) {
            callback(_.cloneDeep(state.shippers));
        } else {
            axios.get('/shippers')
                .then(response => {
                    commit('FINISH_SHIPPERS', {callback: callback, shippers: response.data.data});
                });
        }
    },
    LOAD_BAGTYPES: ({commit, dispatch, state}, callback) => {
        if (state.bagTypesLoaded) {
            callback(_.cloneDeep(state.bagTypes));
        } else {
            axios.get('/bags/types')
                .then(response => {
                    commit('FINISH_BAGTYPES', {callback: callback, bagTypes: response.data.data});
                });
        }
    },
    LOAD_MARKET: ({commit, dispatch, state}, callback) => {
        if (state.marketLoaded && state.market_timeout && state.market_timeout > (new Date()).getTime()) {
            let ret = _.cloneDeep(state.market);
            ret.timeout = state.market_timeout;
            callback(ret);
        } else {
            axios.get('/market-prices-latest')
                .then(response => {
                    commit('FINISH_MARKET', {callback: callback, market: response.data.data});
                });
        }
    },
    GET_REQUEST: ({commit, dispatch, state}, url) => {
        //callback(state.get[url]);
        return new Promise((resolve,reject) => {
            //console.log(state.get_request_cached, state.get_request);
            if (state.get_request.list[url]) {
                let result =

                    {
                        //data: JSON.parse(JSON.stringify(state.get_request[url])),
                        data: _.cloneDeep(state.get_request.list[url]),
                        cached: true
                    };
                //console.log(result);
                resolve(
                    result
                );
            } else {
                axios.get(url)
                    .then(response => {
                        commit('FINISH_GET', {url: url, value: response.data});
                        resolve(_.cloneDeep(response));
                    })
                    .catch((e) => {
                        reject(e);
                    });
            }
        });
    },
};
const mutations = {
    FINISH_BRAND: (state, {callback, brands}) => {
        callback(brands);
        state.brands = _.cloneDeep(brands);
        state.brandLoaded = true;
    },
    FINISH_SHIPPERS: (state, {callback, shippers}) => {
        callback(shippers);
        state.shippers = _.cloneDeep(shippers);
        state.shippingLoaded = true;
    },
    FINISH_BAGTYPES: (state, {callback, bagTypes}) => {
        callback(bagTypes);
        state.bagTypes = _.cloneDeep(bagTypes);
        state.bagTypesLoaded = true;
    },
    FINISH_MARKET: (state, {callback, market}) => {
        state.market_timeout = ((new Date()).getTime() + 60000 * 30); //30 minutes
        market.timeout = state.market_timeout;
        callback(market);
        state.market = _.cloneDeep(market);
        state.marketLoaded = true;
    },
    FINISH_GET: (state, {url, value}) => {
        let get_request = JSON.parse(JSON.stringify(state.get_request));
        get_request.list[url] = JSON.parse(JSON.stringify(value));
        state.get_request = get_request;
        //console.log(state.get_request, get_request);
    },
    FORCE_CACHE_BUST: (state, nothing) => {
        console.log('cache bust');
        state.brandLoaded = false;
        state.shippingLoaded = false;
        state.bagTypesLoaded = false;
        state.marketLoaded = false;
        state.get_request = {list:{}};
        console.log('cache busted');
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
